import $ from "jquery";
window.$ = window.jQuery = $;
import Collapse from 'bootstrap/js/dist/collapse';

require('owl.carousel');

$(document).ready(function(){
	function isMobile(){
		let check = false;
		(function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
		return check;
	}
	var mobile=isMobile();
	if(mobile){
		$('body').addClass('mobile');
	}

	function navIconColorChange(){
		if($('#primaryCtaSlider .owl-item.active .single-cta').hasClass('align-text-left')){
			$('#primaryCtaSlider .owl-nav').removeClass('text-right').addClass('text-left');
		}else{
			$('#primaryCtaSlider .owl-nav').removeClass('text-left').addClass('text-right');
		}
	}
	var $primaryCtaSlider=$('#primaryCtaSlider').owlCarousel({
		dots: false,
		loop: true,
		items: 1,
		nav:true,
		responsive : {
			0 : {
				nav:false,
			},
			768:{
				nav:true,
			}
		},
		autoplay:true,
		autoplayTimeout:8000,
		onTranslated:function(event){
			navIconColorChange();
		},
		animateIn:'fadeIn',
		animateOut:'fadeOut',
		navText:['<svg xmlns="http://www.w3.org/2000/svg" width="33.77" height="32.347" viewBox="0 0 33.77 32.347"><g id="Group_101" data-name="Group 101" transform="translate(-4263.616 -1462.289)" opacity="0.75"><path id="Path_94" data-name="Path 94" d="M4297.385,1478.482q0,6.715,0,13.43a2.544,2.544,0,0,1-1.026,2.1,3.24,3.24,0,0,1-3.35.292c-.984-.475-1.961-.962-2.942-1.443l-9.9-4.86-7.64-3.754q-3.687-1.809-7.376-3.614a2.389,2.389,0,0,1-1.53-2.048,2.236,2.236,0,0,1,1.381-2.2c2.121-1.065,4.262-2.1,6.4-3.148l9.878-4.849,9.9-4.856c.546-.267,1.094-.531,1.634-.806a3.258,3.258,0,0,1,3.092-.083,2.485,2.485,0,0,1,1.437,1.961,7.556,7.556,0,0,1,.046.987Q4297.388,1472.034,4297.385,1478.482Z" fill="#323233"/></g></svg>','<svg xmlns="http://www.w3.org/2000/svg" width="33.77" height="32.347" viewBox="0 0 33.77 32.347"><g id="Group_100" data-name="Group 100" transform="translate(-6025.604 -1462.289)" opacity="0.75"><path id="Path_93" data-name="Path 93" d="M6025.6,1478.444q0-6.715,0-13.431a2.543,2.543,0,0,1,1.026-2.1,3.238,3.238,0,0,1,3.35-.292c.984.475,1.961.961,2.942,1.443l9.9,4.86,7.64,3.754q3.687,1.809,7.376,3.613a2.391,2.391,0,0,1,1.53,2.049,2.238,2.238,0,0,1-1.382,2.2c-2.12,1.065-4.261,2.1-6.394,3.147q-4.938,2.426-9.878,4.849t-9.9,4.856c-.546.268-1.094.531-1.634.806a3.259,3.259,0,0,1-3.092.084,2.489,2.489,0,0,1-1.438-1.961,7.563,7.563,0,0,1-.045-.987Q6025.6,1484.89,6025.6,1478.444Z" fill="#fff"/></g></svg>']
	});

	$('#primaryCtaSlider .left').on('click',function(){
		$primaryCtaSlider.trigger('prev.owl.carousel');
	});

	$('#primaryCtaSlider .right').on('click',function(){
		$primaryCtaSlider.trigger('next.owl.carousel');
	});

	$('#imageSlider').owlCarousel({
		dots: false,
		loop: true,
		items: 1,
		nav:false,
		autoplay:true,
		autoplayTimeout:8000,
		animateIn:'fadeIn',
		animateOut:'fadeOut'
	});

	var $baristasSlider=$('#baristasSlider').owlCarousel({
		dots: false,
		loop: true,
		items: 1,
		nav:false,
		autoplay:true,
		autoplayTimeout:5000,
		animateIn:'fadeIn',
		animateOut:'fadeOut'
	});
	$('#baristasSlider .dots .dot').on('click',function(){
		var $this=$(this);
		$baristasSlider.owlCarousel('to',[$this.attr('data-slide')]);
	});

	var $secondaryCtaSlider=$('#secondaryCtaSlider').owlCarousel({
		dots: false,
		loop: true,
		items: 1,
		nav:false,
		autoplay:true,
		autoplayTimeout:5000,
		// animateIn:'fadeIn',
		// animateOut:'fadeOut',
	});

	$('#secondaryCtaSlider').on('click','.dot',function(){
		var $this=$(this);
		$secondaryCtaSlider.owlCarousel('to',[$this.attr('data-slide')]);
	});

	$('#secondaryCtaSlider .left').on('click',function(){
		$secondaryCtaSlider.trigger('prev.owl.carousel');
	});

	$('#secondaryCtaSlider .right').on('click',function(){
		$secondaryCtaSlider.trigger('next.owl.carousel');
	});

	$('#testimonialSlider').owlCarousel({
		dots: true,
		loop: true,
		items: 1,
		nav:false,
		autoplay:true,
		autoplayTimeout:5000
	});
	$('#gallerySlider').owlCarousel({
		dots: false,
		loop: false,
		items: 1,
		nav:false,
		// autoplay:true,
		// autoplayTimeout:5000,
		// animateIn:'fadeIn',
		// animateOut:'fadeOut',
		navText:['<svg xmlns="http://www.w3.org/2000/svg" width="33.77" height="32.347" viewBox="0 0 33.77 32.347"><g id="Group_101" data-name="Group 101" transform="translate(-4263.616 -1462.289)" opacity="0.75"><path id="Path_94" data-name="Path 94" d="M4297.385,1478.482q0,6.715,0,13.43a2.544,2.544,0,0,1-1.026,2.1,3.24,3.24,0,0,1-3.35.292c-.984-.475-1.961-.962-2.942-1.443l-9.9-4.86-7.64-3.754q-3.687-1.809-7.376-3.614a2.389,2.389,0,0,1-1.53-2.048,2.236,2.236,0,0,1,1.381-2.2c2.121-1.065,4.262-2.1,6.4-3.148l9.878-4.849,9.9-4.856c.546-.267,1.094-.531,1.634-.806a3.258,3.258,0,0,1,3.092-.083,2.485,2.485,0,0,1,1.437,1.961,7.556,7.556,0,0,1,.046.987Q4297.388,1472.034,4297.385,1478.482Z" fill="#323233"/></g></svg>','<svg xmlns="http://www.w3.org/2000/svg" width="33.77" height="32.347" viewBox="0 0 33.77 32.347"><g id="Group_100" data-name="Group 100" transform="translate(-6025.604 -1462.289)" opacity="0.75"><path id="Path_93" data-name="Path 93" d="M6025.6,1478.444q0-6.715,0-13.431a2.543,2.543,0,0,1,1.026-2.1,3.238,3.238,0,0,1,3.35-.292c.984.475,1.961.961,2.942,1.443l9.9,4.86,7.64,3.754q3.687,1.809,7.376,3.613a2.391,2.391,0,0,1,1.53,2.049,2.238,2.238,0,0,1-1.382,2.2c-2.12,1.065-4.261,2.1-6.394,3.147q-4.938,2.426-9.878,4.849t-9.9,4.856c-.546.268-1.094.531-1.634.806a3.259,3.259,0,0,1-3.092.084,2.489,2.489,0,0,1-1.438-1.961,7.563,7.563,0,0,1-.045-.987Q6025.6,1484.89,6025.6,1478.444Z" fill="#fff"/></g></svg>'],
		responsive : {
			0 : {
				nav:true,
				loop:true
			},
			768:{
				nav:false,
			}
		}
	});

	$('.video-outer .play-btn').on('click',function(){
		var $this=$(this);
		$this.fadeOut(300);
		$this.closest('.video-outer').find('video').get(0).play();
	});

	$('.common-video').owlCarousel({
		items:1,
		dots: false,
		video:true,
		mouseDrag:false,
		touchDrag:false,
		pullDrag:false,
		nav:false,
		freeDrag:false
	});

	var $bannerSlider=$('#banner').owlCarousel({
		dots: false,
		loop: true,
		items: 1,
		nav:true,
		navText:['<svg xmlns="http://www.w3.org/2000/svg" width="33.77" height="32.347" viewBox="0 0 33.77 32.347"><path id="Path_416" data-name="Path 416" d="M2265.125,473.165q0,6.715,0,13.43a2.543,2.543,0,0,1-1.026,2.1,3.238,3.238,0,0,1-3.35.292c-.984-.475-1.961-.961-2.942-1.443l-9.9-4.86-7.64-3.754q-3.687-1.809-7.376-3.613a2.39,2.39,0,0,1-1.53-2.049,2.236,2.236,0,0,1,1.382-2.2c2.12-1.065,4.261-2.1,6.394-3.147q4.938-2.426,9.878-4.849l9.9-4.857c.546-.267,1.094-.531,1.634-.805a3.258,3.258,0,0,1,3.092-.084,2.488,2.488,0,0,1,1.438,1.961,7.522,7.522,0,0,1,.045.987Q2265.127,466.719,2265.125,473.165Z" transform="translate(-2231.356 -456.973)" fill="#fff"/></svg>','<svg xmlns="http://www.w3.org/2000/svg" width="33.771" height="32.347" viewBox="0 0 33.771 32.347"><path id="Path_413" data-name="Path 413" d="M3985.294,473.127q0-6.716,0-13.43a2.547,2.547,0,0,1,1.026-2.1,3.242,3.242,0,0,1,3.351-.292c.984.475,1.961.962,2.941,1.443l9.9,4.86,7.641,3.754q3.686,1.809,7.375,3.614a2.39,2.39,0,0,1,1.531,2.048,2.238,2.238,0,0,1-1.382,2.2c-2.121,1.065-4.262,2.1-6.394,3.147l-9.878,4.85-9.9,4.856c-.545.267-1.094.531-1.634.8a3.255,3.255,0,0,1-3.092.084,2.485,2.485,0,0,1-1.437-1.961,7.785,7.785,0,0,1-.046-.987Q3985.293,479.573,3985.294,473.127Z" transform="translate(-3985.293 -456.973)" fill="#fff"/></svg>'],
		autoplay:true,
		autoplayTimeout:5000,
		animateIn:'fadeIn',
		animateOut:'fadeOut',
		responsive : {
			0 : {
				nav:false,
				dots:true
			},
			768:{
				nav:true,
			}
		}
	});


	var $header=$('#header'),
	$fullMenu=$('#fullMenu');
	$('#openMenu').on('click',function(){
		$fullMenu.fadeIn();
	});
	$('#closeMenu').on('click',function(){
		$fullMenu.fadeOut();
	});
	// $(document).scroll(function() {
	// 	if($(window).scrollTop()>20){
	// 		$header.addClass('scrolled');
	// 	}
	// 	else{
	// 		$header.removeClass('scrolled');
	// 	}
	// });
	// if($(window).scrollTop()>20){
	// 	$header.addClass('scrolled');
	// }
	$header.on('mouseleave',function(){
		if(!mobile){
			$('.has-sub-menu.opened').removeClass('opened');
		}
	});

	var $openMobileLinks=$('#openMobileLinks');
	var $mobileButtons=$('#mobileButtons');

	$openMobileLinks.on('click',function(){
		$mobileButtons.toggleClass('shown');
	});

	$(document).mouseup(function(e) {
		if (!$openMobileLinks.is(e.target) && $openMobileLinks.has(e.target).length === 0) {
			$mobileButtons.removeClass('shown');
		}
	});

	$('.has-sub-menu>a,.has-sub-sub-menu>a').on('click',function(e){
		var $this=$(this);
		// if(mobile){ 
			if(!$this.parent().hasClass('opened')){
				e.preventDefault();
				$this.parent().addClass('opened').siblings().removeClass('opened');
			}
		// }
	});
	$('.has-sub-menu').on('mouseenter',function(e){
		var $this=$(this);
		if(!mobile){ 
			if(!$this.hasClass('opened')){
				e.preventDefault();
				$this.addClass('opened').siblings().removeClass('opened');
			}
		}
	});
	$('.has-sub-menu').on('mouseleave',function(e){
		var $this=$(this);
		if(!mobile){ 
			$this.removeClass('opened');
		}
	});

	$(function(){
		$('.show-search').on('click',function(){
			$(".search-box").addClass('open');
			$(".search-form").find("input").focus();
		})
		$(".search-form").find("input").on("focusout",function(){
			$(".search-box").removeClass("open");
		})
	})

})